import styled from 'styled-components';
import {dFlexBetween} from '../../../globalVariables/GlobalFlex';
import {getPrimitive, getSpacing} from '@tickchak/react-share/app';

export const actions = styled.div`
    ${dFlexBetween};
    gap: ${getSpacing('spaceSm')};
`;
export const separator = styled.div`
    width: 1.5px;
    height: 35px;
    background-color: ${getPrimitive('blackAlphas.black10')};
`;